/* What a list card SAYS when it has no rows — the box the sentence stands in, and the two buttons a
 * way out is offered with.
 *
 * Promoted from `pages/plan-library/ui/ListStates.module.css` on 17 September 2026, on its second
 * consumer: the exercise library's four absences stand in the same centred box with the same two
 * treatments, because both screens are a list card under the same canon. The block is unchanged.
 *
 * `EmptyState` supplies the drawing, the sentence and the TONE; this supplies the box around it and
 * the controls under it. A surface states its own SKELETON, which is the shape of its own rows and
 * could not be written once.
 *
 * Nothing is declared on both sides: a property stated here and in a consumer's own stylesheet is
 * settled by chunk order, which differs between the dev server and the build. */

.state {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: var(--space-4);
  align-items: center;
  justify-content: center;
  min-height: 0;
  padding: var(--space-6) var(--space-5);
  text-align: center;
}

.actions {
  display: flex;
  gap: var(--space-2);
  align-items: center;
}

/* The geometry of the primary; the fill, the ink, the lip, the hover and the focus ring are all
 * `shared/ui/emberButton.module.css`'s, and nothing here may restate one. */
.primary {
  display: inline-flex;
  align-items: center;
  height: var(--h-control);
  padding: var(--space-0) var(--space-3);
  font-size: var(--fs-button-sm);
  font-weight: var(--fw-bold);
  letter-spacing: var(--ls-heading);
  border-radius: var(--radius-sm);
}

/* A `<button>` on three of the four states and a `<Link>` on the fourth — the clients scope's way out
 * is the roster, which is a navigation rather than an action. `text-decoration` is the one
 * declaration a button did not need. */
.ghost {
  display: inline-flex;
  align-items: center;
  height: var(--h-control);
  padding: var(--space-0) var(--space-3);
  font-size: var(--fs-button-sm);
  font-weight: var(--fw-bold);
  line-height: var(--lh-auto);
  letter-spacing: var(--ls-heading);
  color: var(--text-2);
  background: var(--bg-card);
  border: var(--border-hairline) solid var(--border-2);
  border-radius: var(--radius-sm);
  cursor: pointer;
  text-decoration: none;
}

.ghost:hover {
  color: var(--text);
}

.ghost:focus-visible {
  outline: var(--border-focus) solid var(--text);
  outline-offset: var(--space-1px);
}
